import { atomFamily } from "jotai/utils";

import { AppFlowRoute } from "./appFlow";
import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";
import { DigitalJourneyFlowRoute } from "./digitalJourneyAppFlow";

const sessionLatestReachedCheckpointFlowPageAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<AppFlowRoute | DigitalJourneyFlowRoute | null>(`latestCheckpoint-${sessionId}`, null)
);
export const latestReachedCheckpointFlowPageAtom = createDerivedSessionAtom<AppFlowRoute | DigitalJourneyFlowRoute | null>(
  sessionLatestReachedCheckpointFlowPageAtom
);